var map = {
	"./UKflag.png": 79993,
	"./VNflag.png": 42921,
	"./android.png": 88942,
	"./avatar.jpg": 88084,
	"./banner-img.png": 8011,
	"./bnf1.png": 85864,
	"./bnf2.png": 39075,
	"./bnf3.png": 74970,
	"./checkbox.png": 41144,
	"./checked.png": 75088,
	"./display.png": 64553,
	"./facebook.png": 32799,
	"./flag.png": 31869,
	"./form-bg-mb.png": 22649,
	"./form-bg.png": 23213,
	"./form-logo.png": 63553,
	"./game.png": 41005,
	"./hidden.png": 41548,
	"./input-share-checked.png": 17425,
	"./input-share.png": 16997,
	"./insta.png": 32346,
	"./ios.png": 37668,
	"./logo-myvtc.png": 14066,
	"./menu-mb.png": 58592,
	"./otp.png": 79104,
	"./pc.png": 46128,
	"./qr.png": 17026,
	"./search.png": 34319,
	"./secure1.png": 39971,
	"./secure19.png": 25098,
	"./secure2.png": 54696,
	"./secure3.png": 52561,
	"./secure33.png": 42990,
	"./secure999.png": 87929,
	"./signup1.png": 21262,
	"./signup2.png": 40037,
	"./signup3.png": 22524,
	"./user-avt1.png": 18297,
	"./user-avt2.png": 4290,
	"./user-avt3.png": 67947,
	"./warning.png": 41823,
	"./youtube.png": 22616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;